import { hasJaneDefinedRowEnabled } from '@iheartjane/menu';

import type { CustomMenuLabels, FilterSelectItem } from '@jane/search/types';
/* eslint-disable-next-line no-restricted-imports */
import type { Store } from '@jane/shared/models';

import { CATEGORY_COLORS, CATEGORY_ICONS } from './constants';
import { facetToFilter } from './facetToFilter';

interface BuildSaleFilterItemsOptions {
  branded?: boolean;
  customLabels?: CustomMenuLabels['root_types'];
  customRows?: Store['custom_rows'];
  rootTypeFacets?: { [label: string]: number };
  storeId?: Store['id'];
  storeState?: string | null;
}

/**
 * Builds the sale item for the 'Deals and rewards' filter group. Sale is a Jane
 * defined row rather than a product category, so it is offered there instead of
 * with the categories, and only when the store has the row enabled.
 */
export const buildSaleFilterItems = ({
  branded = true,
  customLabels,
  customRows,
  rootTypeFacets,
  storeId,
  storeState,
}: BuildSaleFilterItemsOptions): FilterSelectItem[] => {
  const saleCount = rootTypeFacets?.['sale'];

  if (!saleCount || !hasJaneDefinedRowEnabled(customRows, 'sale')) {
    return [];
  }

  return facetToFilter(
    { sale: saleCount },
    {
      branded,
      customLabels,
      filterGroup: 'Sale',
      iconColor: branded ? CATEGORY_COLORS : undefined,
      icons: CATEGORY_ICONS,
      key: 'root_types',
      storeId,
    },
    storeState
  );
};
